// extracted by mini-css-extract-plugin
module.exports = {"container":"ValuePropositionItem_theme1_container__uvkWF","value_text":"ValuePropositionItem_theme1_value_text__OCsar"};